export const Constants = {
    BANNER_HEADING: 'Welcome to the Data Administration',
    BANNER_PARAGRAPH: 'CPQ platform! Simplify your process to manage data.',
    BREADCRUMB_NAME: "Manage Data",
    ERRORMESSAGE:"Something went wrong. Please try again later.",
    SESSIONSEARCH: "Search in Service Distribution Data",
    STRING:"string",
    SEARCH: "Search",
    EDIT: "Edit",
    SAVE: "Save",
    ACTION: "Action",
    TOTAL_RESULT: "Total Results",
    DOWNLOADTEMPLATE:"Download Template",
    DOWNLOADDATA:"Download Data",
    DOWNLOAD:"Download",
    CONFIRM:"Confirm",
    BULKUPLOAD:"Bulk Upload",
    PARTIALUPLOAD:"Partial Upload",
    ADD:"Add",
    PRODUCT:"Product",
    FEETYPE:"Fee Type",
    ADDPRODUCT:"Add Product",
    WRONGFILETYPE:"Please upload correct file. Use excel template for reference.",
    EMPTYFILEERROR:"No data found!. Please check the uploaded file.",
    INVALIDHEADERERROR:"Invalid column header",
    REFERTEMPLATE:"Use excel template for reference",
    INVALIDDATA:"Uploaded File contains invalid data. Please Re-Upload with correct data",
    FAILED:"File Upload Failed. Please try again later.",
    INVALIDFILE:"File Upload Failed. Please use another file.",
    ASENDING:"asc",
    DESCENDING:"desc",
    NOCHANGE:"No Changes to Save",
    SAVESUCCESSFUL:"Product Pricing is updated successfully",
    SAVEFAILED:"Product Pricing update failed. Please try again",
    PAGECOUNT:10,
    INITALPAGENO:1,
    FETCHINGDATA:"Fetching data. Please wait...",
    NODATATABLE:"No Data available. Please upload.",
    PARTIALUPLOADCONFIRM:"This will append the uploaded data with the exisiting data.",
    BULKUPLOADCONFIRM:"This will clear the exisiting data and keep the uploaded data.",
    SHEETNAME:"Sheet1",
    REJCTDATAERROR:"Please download the invalid records, make the corrections and re-upload using Upload",
    UPLOADSUCCESSFUL:`Data uploaded successfully`,
    INVALIDCOUNTRY:"Invalid Country,",
    INVALIDPRODUCT:"Invalid Product,",
    INVALIDPRODUCTVARIENT:"Invalid Product Varient",
    INVALIDCOMPONENT:"Invalid Component,",
    INVALIDTASK:"Invalid Task,",
    INVALIDPRIMARY:"Invalid Primary Service Center,",
    INVALIDCURRENCY:"Invalid Currency,",
    CORRECTNUMBERERROR:"Should be a positive number,",
    CORRECTPOSITIVENUMBERERROR:"Should be a number between 0 and 100,",
    INVALIDDECIMALCOUNT:"decimal values should be limited to a maximum of six digits,",
    INVALIDNOOFHOURS:"Invalid Number of Hours,",
    INVALIDUTILIZATIONDISTRIBUTION:"Invalid Utilization Percentage for,",
    INVALIDPRICINGSTRUCTURE:"is Invalid Pricing Structure,",
    INVALIDCURRENCYCODE:"Invalid Currency Code,",
    INVALIDCURRENCYNAME:"Invalid Currency Name,",
    INVALIDNOOFSESSION:"No of Sessions should be whole numbers between 1 and 25,",
    INVALIDMINUTES:"Minutes should be postivie whole numbers,",
    INVALIDSTAFFPRODUCTIVITY:"Staff Productivity should be 100,",
    INVALIDSUM:"Total of % WPO Delivered and % Ext. Affiliate Delivered should be 100,",
    INVALIDRANGE:"value should be a whole number between 1 to 1000000000,",
    INVALIDMAXANDMIN:"'Maximum' should be greater than 'Minimum',",
    MAXNUMBER:1000000000,

}
export const ButtonType={
    DOWNLOADTEMPLATE:0,
    DOWNLOADDATA:1,
    BULKUPLOAD:2,
    PARTIALUPLOAD:3
}
export const TabEnum={
    SESSIONUSAGEPERCASE:"0",
    STAFFTIME:"1",
    STAFFPRODUCTIVITY:"2",
    STAFFCOST:"3",
    SERVICEDISTRIBUTION:"4",
    EXTERNALCOST:"5",
    OVERHEADCOST:"6",
    WEBCOST:"7",
    MARGINTABLE:"8",
    PRODUCTPRICINGMODELS:"9",
    RRCIANDTRAININGPRICING:"10",
    ADDITIONALCOUNSELINGPRICING:"11",
    PATHWAYSPRICING:"12",
    GWQPRICING:"13",
    NPRTWPRICING:"14",
    CURRENCY:"15",
    ENHANCEDLANDFAVAILABILITY:"16"
}
export const DataTabs = [
    "Session Usage per Case",
    "Staff Time",
    "% Delivery & Staff Productivity",
    "Staff Cost & Department",
    "Service Distribution",
    "External Costs",
    "Overhead Costs",
    "Web Cost",
    "Margin Table",
    "Product Pricing Models",
    "RRCI&Training Pricing Table",
    "AdditionalCounselingPricing",
    "Pathways pricing table",
    "GWQ Pricing Table",
    "NPRTW Pricing Table",
    "Currency Table",
    "Enhanced L & F availability"
  ];
